import React from 'react';
import { Card, Spin, Typography, Button } from 'antd';
import { useChat } from '../context/ChatContext';

const { Title, Text } = Typography;

const Search = () => {
    const { leave } = useChat();

    return (
        <Card style={{ maxWidth: 400, margin: '100px auto', borderRadius: 15, textAlign: 'center' }}>
            <Spin size="large" />
            <Title level={4} style={{ marginTop: 20 }}>Փնտրում ենք զրուցակից...</Title>
            <Text type="secondary">Համապատասխանեցնում ենք ձեր նախասիրություններին</Text>
            <Button block style={{ marginTop: 20 }} onClick={leave}>Չեղարկել</Button>
        </Card>
    );
};

export default Search;
